module.exports = __webpack_public_path__ + "img/2.2f6018a9.png";